// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3BFPI","location":"Header_location__2TrXj"};